import { WifiOnboarding } from "@/components/Elemnt/Onboarding/WifiOnboarding";
import { useParams } from "react-router";

const WifiOnboardingPage = () => {
  const { appToken = "" } = useParams();
  return <WifiOnboarding appToken={appToken} />;
};

export default WifiOnboardingPage;
